import { LocationStrategy } from '@angular/common';
import { Component, Input } from '@angular/core';


@Component({
  selector: 'mmu-striped-diamond-bg',
  templateUrl: './mmu-striped-diamond-bg.component.svg',
  styleUrls: ['./mmu-striped-diamond-bg.component.scss']
})
export class MmuStripedDiamondBgComponent {

  @Input() imgDir: string;

  constructor(
    private _locationStrategy: LocationStrategy
  ) {
    this.imgDir = this._locationStrategy.getBaseHref() + 'assets/img/';
  }


}
